interface IConverter<T> {
    toControl(value: undefined | string): undefined | T;
    toModel(value: undefined | T): undefined | string;
}

export const dateConverter: IConverter<string> = {
    toControl: x => x,
    toModel: x => x,
};

export const dateConverterFss: IConverter<string> = {
    toControl: data => {
        if (data == undefined) {
            return undefined;
        }
        return data.split("-").reverse().join(".");
    },
    toModel: data => {
        if (!data) {
            return "";
        }
        return data.split(".").reverse().join("-");
    },
};
